(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.mainImage = this.querySelector('.product__image--main img');
        this.addEventListener('click', this.onThumbnailClick.bind(this));
      }

      onThumbnailClick(event) {
        const button = event.target.closest('.product__thumbnail');
        if (!button || !this.mainImage) return;

        this.mainImage.removeAttribute('srcset');
        this.mainImage.removeAttribute('sizes');
        this.mainImage.src = button.dataset.fullSrc;
        this.mainImage.alt = button.dataset.alt || '';

        this.querySelectorAll('.product__thumbnail').forEach((thumbnail) => {
          const isActive = thumbnail === button;
          thumbnail.classList.toggle('product__thumbnail--active', isActive);
          thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    }

    customElements.define('product-gallery', ProductGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
